<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="regions"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>

</template>

<script>
    /**
     * Allows the selection of the channel manager region
     */
    export default {
        name: 'ies-input-channel-manager-region',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                regions: [],
                viewValue: this.field.value,
            }
        },
        created:function() {
            this.getRegions();
        },
        methods: {
            getRegions:function(){
				this.regions = [
					{ text: "Please choose..", value: ""},
					{ text: "APAC", value: "APAC" },
					{ text: "EMEA", value: "EMEA" }
				];
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>

